import Button from "@/components/base/Button";
import { clinicInfo } from "@/mocks/site";

/**
 * Closing Call / Contact CTA for the Services page, on a photographic medical
 * environment background with a dark overlay for readable text.
 */
export default function ServicesContactCta() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl border border-background-200">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20bright%20orthopaedic%20clinic%20interior%20with%20soft%20natural%20light%20and%20clean%20neutral%20tones%2C%20premium%20healthcare%20architecture%2C%20calm%20and%20welcoming%2C%20no%20people&width=1600&height=900&seq=ospc-services-contact-2026&orientation=landscape"
              alt="Modern orthopaedic clinic interior at Ortho Spine Care"
              title="Contact Ortho Spine Care, Trichy"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-950/70 to-primary-950/40" aria-hidden="true"></div>

          <div className="relative grid grid-cols-1 gap-6 p-7 md:p-12 lg:grid-cols-12 lg:items-center">
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-2 rounded-full border border-accent-300/40 bg-accent-500/20 px-3.5 py-1.5 font-label text-xs font-semibold uppercase tracking-[0.16em] text-background-100">
                Not sure where to start?
              </span>
              <h2 className="mt-5 font-heading text-2xl font-semibold leading-tight text-background-50 md:text-3xl">
                Talk to our team and get the right care
              </h2>
              <p className="mt-3 max-w-xl font-body text-sm leading-relaxed text-background-200 md:text-base">
                Call the clinic directly to speak with our team, or send us a message with your question. We will guide
                you to the right service and arrange a convenient appointment time.
              </p>
              <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-3 font-body text-sm text-background-200">
                <li className="flex items-center gap-2">
                  <i className="ri-phone-fill text-accent-300" aria-hidden="true"></i>
                  <a href={clinicInfo.phoneHref} className="hover:text-background-50">
                    {clinicInfo.phoneDisplay}
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-whatsapp-line text-accent-300" aria-hidden="true"></i>
                  <a
                    href={clinicInfo.whatsappHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Chat with us on WhatsApp"
                    className="hover:text-background-50"
                  >
                    WhatsApp us
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-accent-300" aria-hidden="true"></i>
                  {clinicInfo.addressFull}
                </li>
              </ul>
            </div>
            <div className="flex flex-col gap-3 lg:col-span-5 lg:items-end">
              <Button href={clinicInfo.phoneHref} size="lg" icon="ri-phone-fill" className="w-full lg:w-auto">
                Call the Clinic
              </Button>
              <Button
                href={clinicInfo.whatsappHref}
                variant="light"
                size="lg"
                icon="ri-whatsapp-line"
                className="w-full lg:w-auto"
              >
                Chat on WhatsApp
              </Button>
              <Button
                to="/contact"
                variant="light"
                size="lg"
                icon="ri-mail-send-line"
                className="w-full lg:w-auto"
              >
                Contact Us
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}